
import { formatDateTime } from "@/components/mixins";
import { LoadingSpinner } from "@/components/Elements/LoadingSpinner.vue";
import _ from "lodash";

export default {
  name: "CustomTable",
  components: {
    LoadingSpinner,
  },
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, required: true },
    sortBy: { type: String, default: "" },
    sortDescProp: { type: Boolean, default: false },
    filter: { type: String, default: "" },
    filterFunction: { type: Function, default: null },
    currentPage: { type: Number, default: 1 },
    perPage: { type: Number, default: 10 },
    showEmpty: { type: Boolean, default: true },
    emptyText: { type: String, default: "No data found" },
    busy: { type: Boolean, default: false },
    showPagination: { type: Boolean, default: false },
    usePagination: { type: Boolean, default: true },
    totalRows: { type: Number, default: 0 },
  },
  mixins: [formatDateTime],
  data() {
    return {
      sortKey: this.sortBy,
      sortDesc: this.sortDescProp,
      currentPageInternal: 1,
    };
  },
  computed: {
    filteredItems() {
      let data = this.items;
      if (this.filter && this.filterFunction) {
        data = data.filter(this.filterFunction);
      } else if (this.filter) {
        data = data.filter((item) =>
          Object.values(item).some((val) => String(val).toLowerCase().includes(this.filter.toLowerCase()))
        );
      }
      if (this.sortKey) {
        data = [...data].sort((a, b) => {
          if (a[this.sortKey] < b[this.sortKey]) return this.sortDesc ? 1 : -1;
          if (a[this.sortKey] > b[this.sortKey]) return this.sortDesc ? -1 : 1;
          return 0;
        });
      }
      return data;
    },
    pagedItems() {
      if (!this.usePagination) return this.filteredItems;
      const start = (this.currentPageInternal - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },
    totalPages() {
      const total = this.totalRows > 0 ? this.totalRows : this.filteredItems.length;
      return Math.ceil(total / this.perPage) || 1;
    },
  },
  methods: {
    sort(key) {
      if (this.sortKey === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortKey = key;
        this.sortDesc = false;
      }
      this.$emit("sort-changed", { sortBy: this.sortKey, sortDesc: this.sortDesc });
    },
    getValueByPath(obj, path) {
      return _.get(obj, path);
    },
  },
  watch: {
    sortBy(val) {
      this.sortKey = val;
    },
    sortDesc(val) {
      this.sortDesc = val;
    },
    currentPageInternal(val) {
      this.$emit("update:currentPage", val);
    },
  },
}